<template>
  <el-dialog title="后台人工绑定" :visible.sync="show" :before-close="switchDialogShow" width="500px" height="400px">
    <div v-loading="loading">
      <div class="app-container" style="padding-top: 0; margin-top: -10px">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <el-form :model="form" label-position="right" label-width="120px" :rules="Rules">
              <el-form-item label="费控表地址" prop="fee_table_address">
                <el-input placeholder="请输入费控表地址" v-model="form.fee_table_address" clearable required></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input placeholder="请输入手机号" v-model="form.phone" clearable></el-input>
              </el-form-item>
              <el-form-item label="枪号" prop="device_id">
                <el-input placeholder="请输入设备枪号" v-model="form.device_id" clearable></el-input>
              </el-form-item>

              <el-form-item label="车牌" prop="car_no">
                <el-input placeholder="请输入车牌" v-model="form.car_no" clearable></el-input>
              </el-form-item>
              <el-form-item label="车位号" prop="park_no">
                <el-input placeholder="请输入车位号" v-model="form.park_no" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-edit" type="primary" @click="onBindByHandSubmit">提交绑定</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import * as echarts from "echarts"
import { Send_FeeTable_BalanceBindByHand } from "@/api/dev_send_order"
import { GetBalanceErrorPageList, BindFeetableByHand } from "@/api/dev_fee_table"
export default {
  mixins: [pageMixin],
  name: "FeetableInitByHand",
  props: {},
  data() {
    return {
      show: false,
      loading: false,
      form: {
        device_id: "",
        fee_table_address: "",
        car_no: "",
        park_no: "",
        phone: ""
      },
      Rules: {
        fee_table_address: [{ required: true, message: "费控表地址必填", trigger: "blur" }]
      }
    }
  },

  methods: {
    showBindByHand() {
      this.switchDialogShow()
    },

    onBindByHandSubmit() {
      this.loading = true
      BindFeetableByHand(this.form)
        .then((res) => {
          this.$message.success(res.msg)
          this.loading = false
          this.switchDialogShow()
        })
        .catch((error) => {
          this.loading = false
        })
    },
    // 关闭弹窗
    switchDialogShow() {
      this.show = !this.show
    }
  },
  beforeDestroy() {}
}
</script>

<style scoped lang="scss"></style>
